export default class URLParam {
  url: URL;
  params: any = {};

  constructor(url: string) {
    this.url = new URL(url);
    let urlParamString: String = (this.url.search || "").replace("?", "");
    let chunks: Array<string> = urlParamString.split("&");

    chunks.forEach((item: any) => {
      let itemSplit: Array<string> = item.split("=");
      if (itemSplit.length == 2) {
        this.params[itemSplit[0]] = itemSplit[1];
      }
    });
  }

  get(param: string) {
    return this.params[param] || null;
  }
}
